import React, { useEffect, useState } from 'react'

import {
  Button,
  CheckBox,
  CurrencyInput,
  Grid,
  Input,
  InputMask,
  Line,
  Picker,
  Row,
  Select,
  SimpleCollapse
} from 'components'
import { DownloadIcon, ViewFileIcon } from 'components/Icons'
import { useException, useFile, useLoading, useModal, useAuth } from 'hooks'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { IResponseTypes } from 'services/core/genericEntityGST'
import {
  ContratoItensSegurancaFiltersServices,
  ContratoItensSegurancaServices,
  IContratoItensSegurancaResponse,
  IItemSegurancaStatusToDictionaryResponse,
  ITipoReprovacaoToDictionaryResponse,
  IUpdateContratoGSTBody
} from 'services/GST/PesquisaPorContrato'
import { COLORS, SPACING } from 'utils'

import { TableGerenciamento } from './tableGerenciamento'
import ProgressModal from 'components/ProgressBar/ProgressBar'

interface IDocumentacaoColapseProps {
  oldTableData: IContratoItensSegurancaResponse[]
  isFirstGet: boolean
  refreshTable: () => void
}

interface IhandleChangeItensListProps {
  index: number
  value: any
  propName: string
}
export interface IhandleChangeSubItensListProps {
  indexSubItem: number
  indexItemSegurancaTable: number
  value: boolean
}

export const DocumentacaoCollpase: React.FC<IDocumentacaoColapseProps> = ({
  oldTableData,
  isFirstGet
}) => {
  const { viewFile, downloadFile } = useFile()
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const { createCustomException, getException } = useException()
  const { push } = useHistory()
  const { usuarioCsn } = useAuth()
  const [uploadProgress, setUploadProgress] = useState(0);

  const [tableData, setTableData] =
    useState<IContratoItensSegurancaResponse[]>()

  const [updatedTableDataIndexes, setUpdatedTableDataIndexes] = useState<
    number[]
  >([])

  const [oldTableReprovadoValues, setOldTableReprovadoValues] =
    useState<string[]>()
  const [tiposStatusDictionary, setTiposStatusDictionary] = useState<
    IItemSegurancaStatusToDictionaryResponse[]
  >([])
  const [tiposReprovacaoDictionary, setTiposReprovacaoDictionary] = useState<
    ITipoReprovacaoToDictionaryResponse[]
  >([])

  const handleChangeSubItensList = (props: IhandleChangeSubItensListProps) => {
    const switchBool = [...tableData]
    switchBool[props.indexItemSegurancaTable].subitens[
      props.indexSubItem
    ].flOk = props.value
    setTableData(switchBool)
  }

  const handleChangeItensList = (props: IhandleChangeItensListProps) => {
    const partialItensList = [...tableData]

    if (props.propName !== 'cdStatusItem') {
      partialItensList[props.index][props.propName] = props.value
    }

    // Controle do antigo state dos valores de cdReprovado
    if (props.propName === 'cdReprovado') {
      const partialReprovadosList = [...oldTableReprovadoValues]
      partialReprovadosList[props.index] = props.value
      setOldTableReprovadoValues(partialReprovadosList)
    }

    // Controle da mudança de state dos valore de cdReprovado caso mudança em cdStatusItem
    if (props.propName === 'cdStatusItem' && props.value !== 'C') {
      partialItensList[props.index][props.propName] = props.value
      partialItensList[props.index]['cdReprovado'] = ''
    } else if (
      props.propName === 'cdStatusItem' &&
      props.value === 'C' &&
      oldTableReprovadoValues
    ) {
      partialItensList[props.index][props.propName] = props.value
      partialItensList[props.index]['cdReprovado'] = oldTableReprovadoValues[props.index]
    }

    if (!updatedTableDataIndexes.includes(partialItensList[props.index].idAmrItemSegContrato)
    ) {
      setUpdatedTableDataIndexes((oldData) => [
        ...oldData,
        partialItensList[props.index].idAmrItemSegContrato,
        partialItensList[props.index].index = props.index
      ])
    }

    setTableData(partialItensList)
  }

  const handleGetTiposStatus = () => {
    setLoading('loading')

    ContratoItensSegurancaFiltersServices()
      .getItemSegurancaStatusToDictionaryList()
      .then((response) => {
        if (
          response?.status !== 200 ||
          response?.data?.tipo === IResponseTypes['alert']
        ) {
          const { tipo, detalhe, mensagem } = response?.data

          createCustomException({
            detalhe,
            message:
              detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
            tipo: IResponseTypes[tipo]
          })
        }

        if (response?.data?.entity)
          setTiposStatusDictionary(response?.data?.entity)
        setLoading('idle')
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error'
        })
      })
  }

  const handleGetTiposReprovacao = () => {
    setLoading('loading')

    ContratoItensSegurancaFiltersServices()
      .getTipoReprovacaoToDictionaryList()
      .then((response) => {
        if (
          response?.status !== 200 ||
          response?.data?.tipo === IResponseTypes['alert']
        ) {
          const { tipo, detalhe, mensagem } = response?.data

          createCustomException({
            detalhe,
            message:
              detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
            tipo: IResponseTypes[tipo]
          })
        }

        if (response?.data?.entity)
          setTiposReprovacaoDictionary(response?.data?.entity)
        setLoading('idle')
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error'
        })
      })
  }

  const handleUpdateDocumento = () => {
    setLoading('loading')

    ContratoItensSegurancaServices()
      .updateItensSeguranca(
        tableData
          .filter((data) =>
            updatedTableDataIndexes.includes(data.idAmrItemSegContrato) && data.index !== null
          )
          .map((item) => ({
            ...item,
            cdMatricula: usuarioCsn?.NmMatricula?.trim(),
            cdReprovado: item.cdReprovado === "P" && item.subitens.filter(sub => sub.flOk === true).length > 0 ? item.cdReprovado : "T",
            cdStatusItem: item.cdStatusItem === 'none' ? undefined : item.cdStatusItem, // VERIFICAR SE REALMENTE É UM CONTRATO PARCIAL COM ALGUM SUBITEM COM STATUS OK
            qtDiasPendentes: item.qtDiasPendentes
              ? parseInt(item.qtDiasPendentes as any)
              : 0
          })) as IUpdateContratoGSTBody[]
      )
      .then((response) => {
        const { tipo, detalhe, mensagem } = response?.data
        if (
          response?.status !== 200 ||
          response?.data?.tipo === IResponseTypes['alert']
        ) {
          createCustomException({
            detalhe: detalhe || 'Alerta',
            message: mensagem || detalhe,
            tipo: IResponseTypes[tipo]
          })
        }

        showModal({
          handleConfirm: () => push('/gst/pesquisa-por-contrato'),
          hideButtonCancel: true,
          message: mensagem || 'Dados atualizados com sucesso.',
          txtButtonConfirm: 'OK',
          type: 'success'
        })

        setLoading('idle')
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.message !== 'Request failed with status code 400'
              ? error.message
              : `
            Ocorreu um erro ao fazer a requisição. 
            Verifique se todos os campos estão preenchidos corretamente.
          `,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'alert'
        })
      })
  }

  useEffect(() => {
    if (oldTableData) {
      setTableData(oldTableData)
      setOldTableReprovadoValues(oldTableData.map((item) => item.cdReprovado))
    }
  }, [oldTableData])

  useEffect(() => {
    if (isFirstGet) {
      handleGetTiposStatus()
      handleGetTiposReprovacao()
    }
  }, [isFirstGet])

  const handleViewFile = (gedExternalID: number) => {
    viewFile(
      { gedExternalID },
      1,
      (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadProgress(percentCompleted);

        showModal({
          hideButtonCancel: true,
          message: (
            <ProgressModal percentCompleted={percentCompleted} />
          ),
          txtButtonConfirm: 'OK',
        });
      }
    );
  };



  return (
    <SimpleCollapse title="DOCUMENTAÇÃO">
      {tableData &&
        tableData?.map((itemSeguranca, index) => (
          <>
            <Grid
              gridCols="0.5fr 0.5fr 0.5fr 0.5fr 0.5fr 0.5fr 0.5fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
            >
              <Input
                label="Nome do item de segurança"
                placeholder="Plano de Segurança"
                value={itemSeguranca?.nmItemSeguranca}
                disabled
                onChange={(event) =>
                  handleChangeItensList({
                    index: index,
                    propName: 'nmItemSeguranca',
                    value: event?.target?.value
                  })
                }
              />
              <InputMask
                label="Prazo"
                placeholder="Qtd."
                value={itemSeguranca?.qtPrazo}
                onChange={(event) =>
                  handleChangeItensList({
                    index: index,
                    propName: 'qtPrazo',
                    value: event?.target?.value
                  })
                }
                type="number"
              />
              <Picker
                defaultValue={null}
                formValue="periodo"
                label="Validade"
                value={itemSeguranca?.dtValidade}
                type="dayMonthYear"
                onChange={(date) => {
                  if (moment(date).isValid() || date === null) {
                    handleChangeItensList({
                      index: index,
                      propName: 'dtValidade',
                      value: moment(date).toISOString()
                    })
                  }
                }}
              //disabled={!itemSeguranca?.nuGedExternalId}
              />
              <Select
                label="Status"
                defaultPlaceholderValue={undefined}
                listOptions={
                  itemSeguranca?.nuGedExternalId !== null
                    ? tiposStatusDictionary?.map((tipoStatus) => ({
                      label: tipoStatus?.descricaoDoStatus,
                      value: tipoStatus?.codigoDeStatus
                    }))
                    : tiposStatusDictionary
                      ?.filter(
                        (tipo) =>
                          tipo.codigoDeStatus != 'C' &&
                          tipo.codigoDeStatus != 'O'
                      )
                      .map((tipoStatus) => ({
                        label: tipoStatus?.descricaoDoStatus,
                        value: tipoStatus?.codigoDeStatus
                      }))
                }
                value={itemSeguranca?.cdStatusItem}
                clearSelect={true}
                onChange={(event) =>
                  handleChangeItensList({
                    index: index,
                    propName: 'cdStatusItem',
                    value: event?.target?.value
                  })
                }
              // disabled={!itemSeguranca?.nuGedExternalId}
              />
              <Select
                label="Reprovado"
                listOptions={tiposReprovacaoDictionary?.map(
                  (tipoReprovacao) => ({
                    label: tipoReprovacao?.tipoReprovacaoDescricao,
                    value: tipoReprovacao?.tipoReprovacaoCodigo
                  })
                )}
                value={itemSeguranca?.cdReprovado === "" ? "T" : itemSeguranca?.cdReprovado}
                onChange={(event) =>
                  handleChangeItensList({
                    index: index,
                    propName: 'cdReprovado',
                    value: event?.target?.value
                  })
                }
                disabled={
                  itemSeguranca?.cdStatusItem !== 'C'
                  //  ||
                  // !itemSeguranca?.nuGedExternalId
                } // Habilitado apenas quando Não Conforme
                hidden={itemSeguranca?.cdStatusItem !== 'C'}
              />
              <CurrencyInput
                placeholder="R$"
                label="Risco"
                value={itemSeguranca?.cdStatusItem == 'C' || itemSeguranca?.cdStatusItem == 'P' ? itemSeguranca?.vlRisco : 0}
                onChange={(event) =>
                  handleChangeItensList({
                    index: index,
                    propName: 'vlRisco',
                    value: event?.target?.value
                  })
                }
                disabled
              />
              <InputMask
                label="Dias pendentes"
                placeholder="Qtd."
                value={itemSeguranca?.qtDiasPendentes}
                onChange={(event) =>
                  handleChangeItensList({
                    index: index,
                    propName: 'qtDiasPendentes',
                    value: event?.target?.value
                  })
                }
                type="number"
                disabled
              />
            </Grid>
            <Grid
              gridCols="3fr 1fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
            >
              <Input
                label="Observação"
                placeholder="Observação"
                value={itemSeguranca?.txObservacao}
                onChange={(event) =>
                  handleChangeItensList({
                    index: index,
                    propName: 'txObservacao',
                    value: event?.target?.value
                  })
                }
                count={itemSeguranca?.txObservacao?.length}
                maxLength={300}
              // disabled={!itemSeguranca?.nuGedExternalId}
              />
              <Row alignItems="end" justifyContent="center">
                <ViewFileIcon
                  cursor="pointer"
                  onClick={() => handleViewFile(itemSeguranca?.nuGedExternalId)}
                  disabled={!itemSeguranca?.nuGedExternalId}
                />

                <DownloadIcon
                  cursor="pointer"
                  onClick={() =>
                    downloadFile({
                      gedExternalID: itemSeguranca?.nuGedExternalId
                    })
                  }
                  disabled={!itemSeguranca?.nuGedExternalId}
                />
              </Row>
            </Grid>
            {itemSeguranca?.subitens &&
              itemSeguranca?.cdStatusItem === 'C' && // Não conforme
              itemSeguranca?.cdReprovado === 'P' && ( // Parcial
                <Grid gridCols="7fr" margin={`0 0 ${SPACING.spacing50} 0`}>
                  <TableGerenciamento
                    handleChangeSubItensList={handleChangeSubItensList}
                    tableData={itemSeguranca?.subitens}
                    indexItemSegurancaTable={index}
                  />
                </Grid>
              )}
            {
              index + 1 < tableData.length &&
              <Row
                marginTop={SPACING.spacing30}
                marginBottom={SPACING.spacing30}
              >
                <div
                  style={{
                    background: `${COLORS.lightGray}`,
                    height: '0.2rem',
                    width: '100%'
                  }}
                />
              </Row>
            }
          </>
        ))}
      <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
        <Button text="Salvar" type="submit" onClick={handleUpdateDocumento} />
      </Row>
    </SimpleCollapse>
  )
}
